import { inferEnvironment } from "./previewUrlUtils";

export const AVAILABLE_TEMPLATES = {
  website: true,
  vibrant: false,
  luxury: false,
  warm: false,
  modern: false,
  organic: false,
};

/**
 * Checks if the current environment is production
 * @returns true if production, false otherwise
 */
export const isProductionEnvironment = () => {
  const env = inferEnvironment();
  return env === "prod";
};

/**
 * Checks if the website generator feature should be fully enabled
 * Disabled in production, enabled in test and dev environments
 */
export const isWebsiteGeneratorEnabled = () => {
  return !isProductionEnvironment();
};

export const WEBSITE_FEATURES = {
  // Website tab in settings - always visible, shows "coming soon" in production
  get WEBSITE_TAB_ENABLED() {
    return true;
  },
  // Website generator wizard route - only enabled in non-production
  get WEBSITE_GENERATOR_WIZARD_ENABLED() {
    return isWebsiteGeneratorEnabled();
  },
};
